// Theme presets and accent colours, exactly as in the design mockups.

export const THEMES = {
  Cream: {
    bg: "#F4F3EE",
    bgAlt: "#E8E6DE",
    surface: "#FFFFFF",
    border: "#E3E1D8",
    ink: "#1B1B18",
    muted: "#6B6A63",
    sidebar: "#1B1B18",
    sidebarHi: "#2C2C28",
    onSidebar: "#F4F3EE",
    onSidebarMuted: "#B8B6AC",
    log: "#1B1B18",
  },
  Dark: {
    bg: "#151514",
    bgAlt: "#262623",
    surface: "#1F1F1D",
    border: "#33332F",
    ink: "#F1F0EA",
    muted: "#A3A199",
    sidebar: "#0E0E0D",
    sidebarHi: "#1F1F1D",
    onSidebar: "#F1F0EA",
    onSidebarMuted: "#9C9A91",
    log: "#0E0E0D",
  },
  Ocean: {
    bg: "#EEF4F7",
    bgAlt: "#DCE7EE",
    surface: "#FFFFFF",
    border: "#D3E0E8",
    ink: "#0F2233",
    muted: "#587082",
    sidebar: "#0F2233",
    sidebarHi: "#1B3448",
    onSidebar: "#EEF4F7",
    onSidebarMuted: "#9DB4C4",
    log: "#0F2233",
  },
};

export const THEME_NAMES = Object.keys(THEMES);

export const ACCENTS = [
  { name: "Teal", value: "#0F766E" },
  { name: "Clay", value: "#D97757" },
  { name: "Blue", value: "#2563EB" },
  { name: "Violet", value: "#7C3AED" },
];

export const DEFAULT_ACCENT = "#0F766E";
export const DEFAULT_THEME = "Cream";

// Semantic colours shared by every theme (from the mockups).
export const SEMANTIC = {
  good: "#15803D",
  goodSoft: "#DCFCE7",
  goodInk: "#14532D",
  warn: "#B45309",
  warnSoft: "#FEF3C7",
  warnInk: "#78350F",
  bad: "#B91C1C",
  badSoft: "#FEE2E2",
  badInk: "#7F1D1D",
  info: "#075985",
  infoSoft: "#E0F2FE",
  gold: "#D6A21A",
  red: "#DC2626",
  live: "#34D399",
  logInfo: "#8DD1C6",
  logWarn: "#F0B95A",
  logError: "#F87171",
  logText: "#D9D7CC",
  logTs: "#7C7A70",
};

export function resolveTokens(themeName, accent) {
  const base = THEMES[themeName] || THEMES[DEFAULT_THEME];
  const a = accent || DEFAULT_ACCENT;
  return { ...base, accent: a, accentSoft: `${a}1A` };
}
